module.exports = __webpack_public_path__ + "static/media/bloodytuesday.06839f94.PNG";